import { gql } from '@apollo/client';

const milestonesQuery = gql`
query milestones{
    milestones{
      id
      name
      link
    }
  }
`


export default { milestonesQuery }